import { TenDLCCoordinatorService } from '@weave/schema-gen-ts/dist/schemas/tendlc/coordinator/v1/coordinator_service.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaTenCoordinatorV1Service = bindHTTP(TenDLCCoordinatorService);
